import AppConstants from '../config/app.constants';

let BulkCashService = function ($http, $q) {

    let commitBulkCash = (branchId, fundingSourceId, bulkCashData, comment, isBulkCash, performedFrom, isDebit, adjustment) => {
        return $http
            .post(AppConstants.api + `/bulk-cash/add-bulk-cash`, {
                branchId,
                fundingSourceId,
                bulkCashData,
                comment,
                isBulkCash,
                performedFrom,
                isDebit,
                adjustment
            })
            .then((res) => {
                return res.data
            })
    }

    let ledgerTransactionLog = (transactionId, branchId) => {
        return $http
            .get(AppConstants.api + `/bulk-cash/transaction-log`, {
                params: {
                    transactionId,
                    branchId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let updateBulkCashFlag = (ledgerTransactionId, bulkCash) => {
        return $http
            .post(AppConstants.api + `/bulk-cash/update-bulk-cash-flag`, {
                ledgerTransactionId,
                bulkCash
            })
            .then((res) => {
                return res.data
            })
    }

    return {
        commitBulkCash,
        ledgerTransactionLog,
        updateBulkCashFlag
    }
}

BulkCashService.$inject = ['$http', '$q']

export default BulkCashService;




// WEBPACK FOOTER //
// ./client/app/services/bulk-cash.service.js